export const ACTIVE_BOOKINGS_LOADED = '@@mah-maps/ACTIVE_BOOKINGS_LOADED';
export const BOOKING_CALCULATED = '@@mah-maps/BOOKING_CALCULATED';
export const RESET_BOOKING_PRICE = '@@mah-maps/RESET_BOOKING_PRICE';
export const BOOKING_CALCULATION_FAILED = '@@mah-maps/BOOKING_CALCULATION_FAILED';